module.exports = __webpack_public_path__ + "static/media/spinner.8ee7fcb9.gif";